// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + (chunkId === 777 ? "recorder" : chunkId) + "." + {"777":"7b6f854a8894ff8f6554","913":"18dc7f58fdce03d4e71a"}[chunkId] + ".js";
};